export default "__VITE_PUBLIC_ASSET__0bdc8472__"